import CesSetting from "./KrCesSetting.vue";
import { install } from "@kurundata-ui-questionnaire/utils/install";

const KrCesSetting = install(CesSetting); // 生成带有 install 方法的组件

export default KrCesSetting;
